/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../../hooks/useSendTelemetry';
import { Spacing } from '../../../themes/GoToTheme';
import { GoToJoinHeading } from '../../../components/Headings/GoToJoinHeading';
import { GoToText } from '../../../components/Texts/GoToText';
import { InstallTroubleshooting } from '../../../components/Troubleshooting/InstallTroubleshooting';

const messages = defineMessages({
  heading: {
    id: 'goto.ongoing.heading',
  },
  caption: {
    id: 'goto.install.ongoing.description',
  },
});

export const GoToInstallOngoing: React.FC = () => {
  const { formatMessage: f } = useIntl();
  const sendTelemetry = useSendTelemetry();
  useEffect(() => {
    sendTelemetry(
      TelemetryComponent.Native,
      TelemetryAction.Onload,
      TelemetryState.Ongoing
    );
  }, [sendTelemetry]);
  return (
    <>
      <GoToJoinHeading heading={f(messages.heading)} />
      <GoToText marginBottom={Spacing.CoreLayout3}>
        {f(messages.caption)}
      </GoToText>
      <InstallTroubleshooting telemetryState={TelemetryState.Ongoing} />
    </>
  );
};
